__turbopack_context__.v({
  "activeProject": "SidebarProjects-module__BQ2TZa__activeProject",
  "addBtn": "SidebarProjects-module__BQ2TZa__addBtn",
  "arrowActive": "SidebarProjects-module__BQ2TZa__arrowActive",
  "arrowContainer": "SidebarProjects-module__BQ2TZa__arrowContainer",
  "collapsed": "SidebarProjects-module__BQ2TZa__collapsed",
  "collapsedContent": "SidebarProjects-module__BQ2TZa__collapsedContent",
  "collapsedWrapper": "SidebarProjects-module__BQ2TZa__collapsedWrapper",
  "container": "SidebarProjects-module__BQ2TZa__container",
  "dropdown": "SidebarProjects-module__BQ2TZa__dropdown",
  "dropdownIcon": "SidebarProjects-module__BQ2TZa__dropdownIcon",
  "dropdownItem": "SidebarProjects-module__BQ2TZa__dropdownItem",
  "dropdownName": "SidebarProjects-module__BQ2TZa__dropdownName",
  "dropdownSeparator": "SidebarProjects-module__BQ2TZa__dropdownSeparator",
  "favicon": "SidebarProjects-module__BQ2TZa__favicon",
  "faviconSmall": "SidebarProjects-module__BQ2TZa__faviconSmall",
  "fullWidthTrigger": "SidebarProjects-module__BQ2TZa__fullWidthTrigger",
  "iconContainer": "SidebarProjects-module__BQ2TZa__iconContainer",
  "info": "SidebarProjects-module__BQ2TZa__info",
  "label": "SidebarProjects-module__BQ2TZa__label",
  "name": "SidebarProjects-module__BQ2TZa__name",
  "nameActive": "SidebarProjects-module__BQ2TZa__nameActive",
  "popover": "SidebarProjects-module__BQ2TZa__popover",
  "popoverCollapsed": "SidebarProjects-module__BQ2TZa__popoverCollapsed",
  "popoverContent": "SidebarProjects-module__BQ2TZa__popoverContent",
  "projectClickArea": "SidebarProjects-module__BQ2TZa__projectClickArea",
  "projectList": "SidebarProjects-module__BQ2TZa__projectList",
  "projectMain": "SidebarProjects-module__BQ2TZa__projectMain",
  "wrapper": "SidebarProjects-module__BQ2TZa__wrapper",
});
